import { Div, Collection, RefString, Span } from "@tblabs/truffle";
import { Tab } from "../../../Models/Product/Tab";


export class DotButtons extends Div
{
    constructor(tabs: Collection<Tab>, selectedTab: RefString)
    {
        super();

        this.DisplayBlock().TextAlignCenter().MarginTop(32);

        this.Append(
            ...tabs.Items.map(x => new Span("●").Class("dot-btn")
                .OnClick(_ => selectedTab.value = x.Label.value)
                .When(selectedTab, v => v === x.Label.value, btn => btn.Color("#e11d48"), btn => btn.Color("#ccc"))
            ));
    }
}
